import { render, staticRenderFns } from "./BetaInfoPage.vue?vue&type=template&id=7bc6d6c0&scoped=true"
import script from "./BetaInfoPage.vue?vue&type=script&lang=js"
export * from "./BetaInfoPage.vue?vue&type=script&lang=js"
import style0 from "./BetaInfoPage.vue?vue&type=style&index=0&id=7bc6d6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6d6c0",
  null
  
)

export default component.exports